module.exports = __webpack_public_path__ + "static/media/vip-background.28ce0afe.jpg";